module.exports = __webpack_public_path__ + "static/media/plus-primary.3fbbe914.svg";